import React, { useEffect, useMemo, useState } from 'react';
import { useEvent } from '../events/event/EventProvider';
import ActionBadge from './ActionBadge';
import BadgeList from './BadgeList';
import './Badges.scss';

const Badges = () => {
  const [{ event, nftProfile, campaign }] = useEvent();
  const [bridgeLevelId, setBridgeLevelId] = useState(null);
  const [stakeLevelId, setStakeLevelId] = useState(null);
  const [actionBadgeLevelId, setActionBadgeId] = useState(null);
  useEffect(() => {
    if (!event?.eventNames) return;

    // Find the key where name is "bridge_badges"
    const bridgeLevelId = Object.keys(event.eventNames).find(key => event.eventNames[key]?.name === 'bridge_badges');

    // Find the key where name is "stake_badges"
    const stakeLevelId = Object.keys(event.eventNames).find(key => event.eventNames[key]?.name === 'stake_badges');

    const actionBadgeLevelId = Object.keys(event.eventNames).find(key => event.eventNames[key]?.name === 'action_badges');

    // Set the level ID
    setStakeLevelId(stakeLevelId);
    setBridgeLevelId(bridgeLevelId);
    setActionBadgeId(actionBadgeLevelId);
  }, [event.eventNames]);

  const bridge_badges = useMemo(() => {
    if (!event?.events?.length) return [];
    return event.events.filter(task => task.levelId === bridgeLevelId);
  }, [event?.events, bridgeLevelId]);

  const stake_badges = useMemo(() => {
    if (!event?.events?.length) return [];

    return event.events.filter(task => task.levelId === stakeLevelId);
  }, [event?.events, stakeLevelId]);

  const action_badges = useMemo(() => {
    if (!event?.events?.length) return [];

    return event.events.filter(task => task.levelId === actionBadgeLevelId);
  }, [event?.events, actionBadgeLevelId]);
  return (
    <>
      <div className='badge-center-text'>
        <div className='text'>
          <p className='profile'>
            Dynamic<span> Badges</span>
          </p>
          <p className='sub-text'>
            Collect real-time badges based on activities within the ecosystem. Dynamically upgrade through increased activity, and downgrade by reducing activity
          </p>
        </div>

        <BadgeList badges={stake_badges} category='stake' />
        <BadgeList badges={bridge_badges} category='bridge' />

        <div className='action_badge_container'>
          <div className='action_badge_text'>
            <p>ACTION BADGES</p>
            <div className='white_line'></div>
          </div>
          {action_badges.map(badge => (
            <ActionBadge badge={badge} />
          ))}
        </div>
      </div>
    </>
  );
};

export default Badges;
